<template>
    <dash
        icon="fa fa-exclamation-circle"
        titulo="ETAPAS E DESPESAS COM ERRO NO COMPROMETIMENTO"
        @click.native="
            $router.push({
                name: 'Sgtec_Gestores_Paineis_Erros_Comprometimentos'
            })
        "
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
